import { useEffect, useState } from "react";
import * as selector from '../../selectors/selectors'
import { useSelector } from 'react-redux';
import { Contact } from "../../models/conversations";
import { ColDef, ColumnApi, GridApi, ValueFormatterParams, ValueGetterParams } from "ag-grid-community";
import PullToRefresh from "react-simple-pull-to-refresh";
import { useDispatch } from "react-redux";
import { LoadBlockedContacts, UpdateContactsMassActionDeletionStatus } from "../../actions";
import GridComponent from "../shared/grid";
import { UtilityService } from "../../services/UtilityService";
import { dateComparator } from "../shared/grid/grid.services";
import PageHeaderComponent from "../shared/page-header.component";
import { setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { ActionLabels, appNote, buttonLabels, ContactsMassAction, ConversationsMassAction, pageTitles, ToasterTexts } from "../shared/constants";
import { MultiSelectBlockIcon } from "../../icon";
import { ContactService } from "../../services/ContactService";
import setToast from "../../helpers/toaster.helper";
import { ToasterType } from "../shared/toaster/toaster.model";
import Confirm_Dialog from "../shared/confirm-dialog.component";

const BlockedContact: React.FC = () => {
    const dispatch = useDispatch()

    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const GetBlockedContacts: Contact[] = useSelector(selector.getBlockedContacts)
    const [gridApi, SetGridApi] = useState<GridApi>(null)
    const [columnApi, SetColumnApi] = useState<ColumnApi>(null)
    const [showMultiActionButtons, setShowMultiActionButtons] = useState<boolean>(false)
    const [selectedRows, setSelectedRows] = useState<Contact[]>([]);
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false)
    const [isLoading, setIsloading] = useState<boolean>(false);



    const BlockedColoumnDefs: ColDef[] = [
        {
            field: "Name",
            headerName: "Name",
            valueGetter: (params: ValueGetterParams) => {
                return !!params.data.Name ? params.data.Name : '--'
            },
            hide: !IsMobileDevice,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        {
            field: "FirstName",
            headerName: "First Name",
            valueGetter: (params: ValueGetterParams) => {
                return !!params.data.FirstName ? params.data.FirstName : '--'
            },
            hide: IsMobileDevice,
            headerCheckboxSelection: true,
            checkboxSelection: true,
        },
        {
            field: "LastName",
            headerName: "Last Name",
            valueGetter: (params: ValueGetterParams) => {
                return !!params.data.LastName ? params.data.LastName : '--'
            },
            hide: IsMobileDevice
        },
        {
            field: "MaskedPhoneNumber",
            headerName: "Phone Number",
            valueFormatter: (params) => {
                return UtilityService.maskPhoneNumberOnLength(params.data.MaskedPhoneNumber)
            },
            valueGetter: (params: ValueGetterParams) => {
                const raw =
                    params.data?.PhoneNumber ||
                    params.data?.MaskedPhoneNumber ||
                    "";
                return `${raw} ${UtilityService.maskPhoneNumberOnLength(raw)} ${raw.replace(/\D/g, "")}`;
            },
        },
        {
            field: "CreatedDateTime",
            headerName: "Updated Date",
            valueFormatter: (params: ValueFormatterParams) => {
                return UtilityService.convertDateToDay(params.data.CreatedDateTime).toString()
            },

            sort: !IsMobileDevice ? 'desc' : null,
            hide: IsMobileDevice,
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.CreatedDateTime, nodeB.data.CreatedDateTime),
            suppressSizeToFit: true
        },
    ]

    const onGridReady = (params) => {
        SetGridApi(params.api);
        SetColumnApi(params.columnApi)
    }
    const searchContact = (e: any) => {
        gridApi.setQuickFilter(e.target.value);
    }

    const onSelectionChanged = () => {
        let SelectedContacts: Contact[] = gridApi.getSelectedRows()
        if (gridApi && SelectedContacts.length > 0) {
            setSelectedRows(SelectedContacts)
            setShowMultiActionButtons(true);
        }
        else {
            setShowMultiActionButtons(false);
            setSelectedRows([])
        }

    }

    const closeConfirmDialog = (isConfim: boolean) => {
        if (isConfim) {
            setIsloading(true)
            let data = selectedRows?.map(x => x.PhoneNumber)
            const buttonName = ContactsMassAction.UNBLOCK
            const MassActioninfo = {
                ButtonName: buttonName,
                selectedConversations: data.length
            }
            ContactService.contactsMassActionDelete(buttonName, data)
                .then((res) => {
                })
                .catch((err) => {
                    if (err.response.status === 404 || err.response.status === 400 || err.response.status === 500) {
                        setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER);
                    }
                    UpdateContactsMassActionDeletionStatus(dispatch, false)
                })
            setSelectedRows([])
            setIsloading(false);
            setShowConfirmDialog(false);
            setShowMultiActionButtons(false);

            localStorage.setItem("contactMassAction", JSON.stringify(MassActioninfo))

            if (buttonName === ConversationsMassAction.UNBLOCK) {
                setToast("Attention: Your contacts are currently being unblocked in the background. Feel free to continue using the application.", ToasterType.INFO)
            }
            UpdateContactsMassActionDeletionStatus(dispatch, true)

        }
        else {
            setShowConfirmDialog(false)
        }
    }

    const gridRefresh = () => {
        LoadBlockedContacts(dispatch)
        if (!!columnApi) {
            columnApi.resetColumnState()
        }

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
    }

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => LoadBlockedContacts(dispatch,));

    useEffect(() => {
        setHeaderTitle(pageTitles.BLOCKED_LIST);
        setRefreshHandler(gridRefresh)

        return setHeaderTitle
    }, []);

    return (
        <>
            <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh} className=''>
                <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                    <div className="py-2">
                        <PageHeaderComponent
                            GridTitle={""}
                            onSearch={searchContact}
                            Count={GetBlockedContacts.length}
                            PlaceHolder={"Find ..."}
                            ShowMultiActionButtons={showMultiActionButtons}
                            MultiActionButtons={[

                                {
                                    Name: ActionLabels.UNBLOCK,
                                    Variant: "primary",
                                    ClassName: "mr-1",
                                    Icon: MultiSelectBlockIcon,
                                    OnClick: () => { setShowConfirmDialog(true) },
                                },

                            ]}
                        />
                    </div>
                    <GridComponent
                        ColumnDefs={BlockedColoumnDefs}
                        RowData={GetBlockedContacts}
                        OnGridReady={onGridReady}
                        OnSelectionChanged={onSelectionChanged}
                        IsPaginationEnabled={!IsMobileDevice}
                        EmptyLabel={"There are no blocked contacts at!"}
                        LockVisible={true}
                    />
                    {showConfirmDialog &&
                        <Confirm_Dialog
                            ButtonName={buttonLabels.UNBLOCK}
                            onClose={closeConfirmDialog}
                            Show={showConfirmDialog}
                            Text={appNote.MASS_ACTION_TEXT.replace("<action>", buttonLabels.UNBLOCK).replace("<name>", selectedRows?.length <= 1 ? ContactsMassAction.CONTACT : `${ContactsMassAction.CONTACT}s`)}
                            Loading={isLoading}
                            IsMobileDevice={IsMobileDevice}
                        />}
                </div>
            </PullToRefresh>
        </>
    );
};

export default BlockedContact;